import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { consumeSubMerchantHandoff } from "@/lib/subMerchantSession";

/**
 * EPS-5027: Ana bayinin açtığı yeni sekme burada karşılanır; alt bayi token'ı bu sekmeye
 * alınır ve panele yönlendirilir.
 */
const SubMerchantSession = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    return consumeSubMerchantHandoff(searchParams.get("h"), (started) =>
      started ? navigate("/", { replace: true }) : setFailed(true),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <h1>
        {failed
          ? t("subMerchantsPage.openFailed", "Alt bayi paneli açılamadı.")
          : "Loading..."}
      </h1>
    </div>
  );
};

export default SubMerchantSession;
